define('viewmodels/configuration/InherentSetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils', 'viewmodels/configuration/RisksAreasfactors', 'viewmodels/configuration/QualitativeSetup'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils, QuantitativeSetup, QualitativeSetup) {
    var title = 'Inherent Setup';
    var InherentVM = {
        activate: activate,
        attached: attached,
        detached: detached,
        ObjGeneralSettings: ObjGeneralSettings,
        title: title,
        utils: utils,
        appsecurity: appsecurity,
        QuantitativeSetup: QuantitativeSetup,
        QualitativeSetup: QualitativeSetup,
        SurveyCategoryList: ko.observableArray([]),
        ControlsAccessIS: ko.observable(false),
        SurveyGroupType: ko.observable(),
        LocaleCheckFlag: ko.observable(false),
        SurveyCategoryTabClick: SurveyCategoryTabClick,
        GetRiskLevels: GetRiskLevels,
        OpenConfigureResponseTypePopup: OpenConfigureResponseTypePopup
    };
    return InherentVM;

    function activate() {
        try {
            if (InherentVM.ObjGeneralSettings === undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((InherentVM.ObjGeneralSettings.LocalizedTextList() !== undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() !== null) && InherentVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                InherentVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (InherentVM.ObjGeneralSettings.LocalizedTextList() == undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() == null || InherentVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || InherentVM.ObjGeneralSettings.LocalizedIndexList() == undefined || InherentVM.ObjGeneralSettings.LocalizedIndexList() == null)
                        InherentVM.LocaleCheckFlag(false);
                    else
                        InherentVM.LocaleCheckFlag(true);
                });
            } else
                InherentVM.LocaleCheckFlag(true);
            //code
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function detached() {
        try {
            //code
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        InherentVM.ControlsAccessIS(true);
                    }
                    else {
                        InherentVM.ControlsAccessIS(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                InherentVM.ControlsAccessIS(true);
            }
            else {
                InherentVM.ControlsAccessIS(false);
            }
            GetSurveyCategoryTabs();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }
    
    function GetSurveyCategoryTabs() {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabs",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    if (jsonResult !== null) {
                        if (jsonResult.length > 0) {
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            $('#loadingMainImgDiv').modal('show');
                            InherentVM.SurveyCategoryList(mappedTabList);
                            $('#InherentTabDiv').tabs();
                            $('#InherentTabDiv').tabs('refresh');
                            $('#InherentTabDiv').tabs({active: 0});
                            $("#InherentTabDiv").removeClass('ui-widget-content');
                            $("#tabContent").removeClass('ui-widget-content');
                            $($('#SurveyCategoryTabsDiv li').get(0)).trigger('click');
                            scrollableTabs();
                            $('#PageButtonsDiv').show();
                        }
                        if (jsonResult.length === 0) {
                            $('#loadingMainImgDiv').modal('hide');
                            $('#errorComp').show();
                            $('#PageButtonsDiv').hide();
                        }
                    }
                    else {
                        $('#loadingMainImgDiv').modal('hide');
                        $('#errorComp').show();
                        $('#PageButtonsDiv').hide();
                    }
                })
                .fail(function (error, status) {
                    if (error.status === 401) {
                        app.showMessage((!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentSetup.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }
    function GetRiskLevels() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetRiskLevels",
                type: "GET",
                headers: headers,
                data: { "AssessmentId": InherentVM.ClickedAssessmentTypeId(), "RiskType": "C" }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {

                    }
                    else {

                        if (JsonResult.CombinedRiskLevelList.length > 0) {
                            var mappedFirstList = $.map(JsonResult.CombinedRiskLevelList, function (result) {
                                return new RiskModel({ RiskLevelId: result.RiskLevelId, RiskLevelName: result.RiskLevelName });
                            });
                            InherentVM.RiskScales(mappedFirstList);
                            //for (var i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                            //    $("#RiskScaleOptions" + AmlCaViewModel.ControlResponselvlList()[i].Id()).multiselect();
                            //}
                        }

                    }
                })
                .fail(function (JsonResult, status) {
                    if (error.status == 401) {
                        app.showMessage((!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterLevels() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function SurveyCategoryTabClick(data, event) {
        try {
            
            $('#loadingMainImgDiv').modal('show');

            $('#SurveyCategoryTabsDiv li').removeClass('active');
            if (data.SurveyGroupShortName() === 'QTDR') {
                InherentVM.SurveyGroupType('QTDR');
                $('#' + data.SurveyCategoryId()).addClass('active');
                ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/configuration/RisksAreasfactors', activationData: { InherentSetupQuantObj: data } } }, InherentVM);
              
            }

            if (data.SurveyGroupShortName() === 'QLDR') {
                InherentVM.SurveyGroupType('QLDR');
                $('#' + data.SurveyCategoryId()).addClass('active');
                ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/configuration/QualitativeSetup', activationData: { InherentSetupQualObj: data } } }, InherentVM);
            }
            $('#loadingMainImgDiv').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureResponseTypePopup(data, event) {
        try {
            if (InherentVM.SurveyGroupType() === 'QTDR') {
                InherentVM.QuantitativeSetup.OpenConfigureResponseTypePopup();
            }
            else if (InherentVM.SurveyGroupType() === 'QLDR') {
                InherentVM.QualitativeSetup.OpenQualRespSetupPopup();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenConfigureResponseTypePopup() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }
});

